import React, { useState, useRef, useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import "../css/shared_css/inputform.css";
import "../css/shared_css/table.css";
import "../css/shared_css/herobutton.css";
import "../css/expenses.css";
import axios from 'axios';
import { backend_url } from "../App.js";

var sorted = null;
var propertySorted = null;
function Expenses() {
    // List of the expenses' values
    let totalList = [
        {"type": "Live", "amount": parseFloat(sessionStorage.getItem("liveTotal") || 0)},
        {"type": "Give", "amount": parseFloat(sessionStorage.getItem("giveTotal") || 0)},
        {"type": "Grow", "amount": parseFloat(sessionStorage.getItem("growTotal") || 0)},
        {"type": "Owe", "amount": parseFloat(sessionStorage.getItem("oweTotal") || 0)}
    ]
    // List of whether the expense values exist yet
    let existList = [
        {"type": "Live", "exists": parseFloat(sessionStorage.getItem("liveExists") || 0)},
        {"type": "Give", "exists": parseFloat(sessionStorage.getItem("giveExists") || 0)},
        {"type": "Grow", "exists": parseFloat(sessionStorage.getItem("growExists") || 0)},
        {"type": "Owe", "exists": parseFloat(sessionStorage.getItem("oweExists") || 0)}
    ]

    let [rows, setRows] = useState(JSON.parse(sessionStorage.getItem("expenseTableRows")) || []);
    let [totalRows, setTotalRows] = useState(parseFloat(sessionStorage.getItem("totalRows")) || 0);

    // Variables relating to if the user is on a mobile device
    const [isMobile] = useState(window.innerWidth <= 480);
    const descriptionHeader = isMobile ? "Desc." : "Description";
    const amntHeader = isMobile ? "Amnt." : "Amount";
    
    let amntRef = useRef(null);

    // Creates a new row in the Expenses' table
    let createMongoRow = async (uid, category, description, date, amount, type) => {
        try {
            const response = await axios.post(backend_url + 'expenseRow', { 
                userID: uid,
                category,
                description,
                date,
                amount,
                type
            });
            let _id = response.data._id;
            setRows([...rows, { category, description, date, amount, type, _id }]);
            sessionStorage.setItem("expenseTableRows", JSON.stringify([...rows, { category, description, date, amount, type, _id }]));
        } 
        catch (error) {
            console.error(error);
        }
    };

    // Creates a new summary total for a user that hasn't entered any expenses yet
    let createMongoTotal = async (uid, amnt, ty) => {
        try {
            const response = await axios.post(backend_url + 'summary', { 
                userID: uid,
                financeTotal: amnt,
                type: ty,
            });
        } 
        catch (error) {
            console.error(error);
        }
    };

    // Deletes a row from the table based on the row's ID
    let deleteMongoRow = async (uid, rID) => {
        try {
            const response = await axios.post(backend_url + 'deleteExpenseRow', { 
                userID: uid,
                _id: rID,
            });
            await updateMongoTotal(uid, sessionStorage.getItem('expenseTotal'), 'expenseTotal');
        } 
        catch (error) {
            console.error(error);
        }
    };

    // Updates the summary to reflect any changes made in the table
    let updateMongoTotal = async (uid, amnt, ty) => {
        try {
            const response = await axios.post(backend_url + 'updateSummary', { 
                userID: uid,
                financeTotal: amnt,
                type: ty,
            });
        } 
        catch (error) {
            console.error(error);
        }
    };

    // Verifies that the given amount is a valid currency amount
    let validateValue = (amnt) => { 
        let regX = /[^0-9.]/g;

        if (amnt.trim().search(regX) !== -1){
            amnt = amnt.replace(regX, "");
            amntRef.current.value = amnt;
            if (amnt.search(/\d+/g) === -1)
            {
                amnt = 0;
            }
        }
        return amnt;
    };
    
    // Maps the categories to their corresponding types
    let getType = (category) => {
        const typeMap = {
            "Live": ["Food", "Housing", "Insurance", "Transportation", "Entertainment", "Personal", "Miscellaneous"],
            "Give": ["Tithing", "Charity"],
            "Grow": ["Emergency", "Retirement"],
            "Owe": ["Student", "Credit", "Tax"]
        };

        for (const [key, value] of Object.entries(typeMap)) {
            if (value.includes(category))
                return key;
        }
        return "Live";
    };

    // Updates the total of the given type by the amount
    let updateTypeTotal = (type, amount) => {
        for (let i = 0; i < 4; i++) {
            if (totalList[i]["type"] == type) {
                let amnt = parseFloat(totalList[i]["amount"]) + amount;
                totalList[i]["amount"] = amnt;
                sessionStorage.setItem(type.toLowerCase() + "Total", amnt);
            }
        }
    };

    // Handles adding a new row to the table
    let onAddRow = async (e) => {
        e.preventDefault();
        // Get the input fields' data
        let uid = sessionStorage.getItem('userID');
        let category = e.target.elements.Category.value; 
        let description = e.target.elements.Purchase.value;
        let date = e.target.elements.Date.value;
        let amount = parseFloat(validateValue(e.target.elements.Amount.value));
        let type = getType(category);

        // Reset the fields
        setCategory("");
        document.getElementById("PurchaseInput").value = "";
        document.getElementById("DateInput").value = "";
        document.getElementById("AmountInput").value = "";

        // Increment the total number of rows
        setTotalRows(totalRows + 1);
        sessionStorage.setItem('totalRows', totalRows);
        
        // Make sure that we actually need to change anything
        if (amount !== 0) {        
            // Update the correct total and create a new row in the table
            updateTypeTotal(type, amount);
            createMongoRow(uid, category, description, date, amount, type);
            // Loop through the amounts
            for (let i = 0; i < 4; i++) {
                if (totalList[i]["type"] == type) {
                    // Update the correct total, and if it wasn't before, set its "exists" value to 1
                    let amnt = totalList[i]["amount"]
                    if (existList[i]["exists"]) {
                        updateMongoTotal(uid, amnt, type.toLowerCase() + "Total");
                    }
                    else {
                        createMongoTotal(uid, amnt, type.toLowerCase() + "Total");
                        existList[i]["exists"] = 1;
                        sessionStorage.setItem(type.toLowerCase + "Total", 1);
                    }
                }
            }
            // Let the user know the field has been added and clear text after a few seconds
            document.getElementById("responseMessage").textContent = "Field Added!";
            try {
                setTimeout(clearMessage, 3000);
            } catch (error) {
                // User navigated before the could be cleared by the timeout function 
            }
        }
    };
    

    let clearMessage = () => {
        document.getElementById("responseMessage").textContent = "";
    };

    // Handles deleting rows
    let onDeleteRow = (index) => {
        // Get data of the row
        let rowToDelete = rows[index];
        let amntToDelete = rowToDelete.amount;
        let type = rowToDelete.type;
        let rID = rowToDelete._id;          
        let uid = sessionStorage.getItem('userID');

        // Loop through the types
        for (let i = 0; i < 4; i++) {
            if (totalList[i]["type"] == type) {
                // Get the new amount by subtracting the amntToDelete from the old amount and save it
                updateTypeTotal(type, -amntToDelete)

                // Find and filter out the row that we're deleting
                let updatedRows = rows.filter((_, i) => i !== index);
                setRows(updatedRows);
                sessionStorage.setItem("expenseTableRows", JSON.stringify(updatedRows));

                // Delete the row from the database and update the total
                deleteMongoRow(sessionStorage.getItem('userID'), rID);
                updateMongoTotal(uid, totalList[i]["amount"], type.toLowerCase() + "Total");
            }
        }
    };

    let [category, setCategory] = useState('');

    let handleCategoryChange = (event) => {
        setCategory(event.target.value);
    };

    // Handles when the user enters something in the amount field
    let handleCurrencyKeyPress = (event) => {
        // Stop from entering multiple periods
        if (event.charCode === 46) {
            if (event.target.value.indexOf('.') !== -1) {
                event.preventDefault();
            }
        } 
        // Check for enter key, allow submission of form if it is
        else if (event.charCode !== 13) { 
            // Check for number only input
            if ((event.charCode > 31) && (event.charCode < 48 || event.charCode > 57)) {
                event.preventDefault();
            }

            // Check for only two decimal places
            let searchVal = event.target.value.search(/\./);
            if (searchVal !== -1 && event.target.selectionStart > searchVal && event.target.value.split('.')[1].length === 2) 
            {
                event.preventDefault();
            }
        }
    };

    // Returns the element used for sorting based on the property specified
    let getSortingElement = (property) => {
        if (property == "category") {
            return document.getElementById("categoryHeader");
        } else if (property == "desc") {
            return document.getElementById("descHeader");
        } else if (property == "date") {
            return document.getElementById("dateHeader");
        } else if (property == "amnt") {
            return document.getElementById("amntHeader");
        } else if (property == "type") {
            return document.getElementById("typeHeader");
        } else {
            return null;
        }
    }

    // Sorts the table based on the selected mode
    let sortTable = (property) => {
        var arrow

        // Set arrow to the previous property accessed        
        arrow = getSortingElement(propertySorted);
        // Clear the previous arrow graphic if there is one
        if (arrow !== null) {
            arrow.removeAttribute('aria-sort')
        }

        // Get the element to change the arrow display
        arrow = getSortingElement(property);
        
        // Get the table as parsed JSON
        let table = JSON.parse(sessionStorage.getItem("expenseTableRows"));

        // Sort the table based on property specified
        table.sort((a,b) => {
            var itemA;
            var itemB;
            switch(property){
                case "category":
                    itemA = a.category.toUpperCase();
                    itemB = b.category.toUpperCase();
                    break;
                case "desc":
                    itemA = a.description.toUpperCase();
                    itemB = b.description.toUpperCase();
                    break;
                case "date":
                    itemA = a.date;
                    itemB = b.date;
                    break;
                case "type":
                    itemA = a.type;
                    itemB = b.type;
                    break;
                default:
                    itemA = a.amount;
                    itemB = b.amount;
            }
            if (itemA < itemB) {
                return -1;
            }
            if (itemA > itemB) {
                return 1;
            }
            return 0;
        });  
        // Change the sort based on ascending or descending
        if (sorted == "ascending" && propertySorted == property) {
            sorted = "descending";
            arrow.setAttribute('aria-sort', 'descending');
        } else {
            table.reverse();
            sorted = "ascending";
            arrow.setAttribute('aria-sort', "ascending");
        }
        propertySorted = property

        // Store the changed table back into the session storage
        sessionStorage.expenseTableRows = JSON.stringify(table);
        setRows(table);
    }
    
    let formatDate = (date) => {
        date = date.split('T')[0];
        return date;
    }

    // Automatically opens the date picker when the date field is clicked on
    let focusDate = () => {
        document.getElementById("DateInput").showPicker(); 
        document.getElementById("DateInput").valueAsDate = new Date();
    }

    //listeners for the sorting buttons
    useEffect(() => {
        // Attach event listeners to the sorting buttons
        const attachEventListeners = () => {
            document.getElementById("categoryButton").addEventListener("click", () => sortTable("category"));
            document.getElementById("descButton").addEventListener("click", () => sortTable("desc"));
            document.getElementById("dateButton").addEventListener("click", () => sortTable("date"));
            document.getElementById("amntButton").addEventListener("click", () => sortTable("amnt"));
            document.getElementById("typeButton").addEventListener("click", () => sortTable("type"));
        };

        attachEventListeners();
    }, []);

return (
    <>
    <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;600;700&display=swap"
        rel="stylesheet"
    />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.0/css/all.min.css"
    />
    <section className='headergv'>
        <Navbar></Navbar>

        <div className="text-box">
        <h1>Expenses</h1>
        <hr />
        <p>What are my expenses?</p>
        <a href="#form-header" className="hero-btn" id="libertyBtn"
        >Click here to enter your expenses</a>
        </div>
    </section>

        <section>
            <h1 id="form-header" className="form-header">Enter your Expenses</h1>
            <div className="containerL" id='containerL'>
                <form action="#" method="POST" onSubmit={onAddRow}>
                <div className="user-details">
                <div className="input-box">
                    <label htmlFor="categoryInput">Category</label>
                    <select
                    className="input-box"
                    name="Category"
                    id="CategoryInput"
                    value={category}
                    onChange={handleCategoryChange}
                    required>
                    
                    <option value="">Select the category</option>
                    
                    <option value="">-- Live --</option>
                    <option value="Food">Food</option>
                    <option value="Housing">Housing</option>
                    <option value="Insurance">Insurance</option>
                    <option value="Transportation">Transportation</option>
                    <option value="Entertainment">Entertainment</option>
                    <option value="Personal">Personal Spending</option>
                    <option value="Miscellaneous">Miscellaneous</option>

                    <option value="">-- Give --</option>
                    <option value="Tithing">Tithing</option>
                    <option value="Charity">Charity</option>
                    
                    <option value="">-- Grow --</option>
                    <option value="Emergency">Emergency Fund</option>
                    <option value="Retirement">Retirement Savings</option>
                    
                    <option value="">-- Owe --</option>
                    <option value="Student">Student Loans</option>
                    <option value="Credit">Credit Cards</option>
                    <option value="Tax">Taxes</option>
                
            </select>
            </div>
    
            <div className="input-box">
              <label for="PurchaseInput" class="visuallyhidden">Description</label>
              <span className="details">Description</span>
              <input type="text" id="PurchaseInput" className="purchaseInput" placeholder="Enter the type of purchase"
                name="Purchase" required />
            </div>
    
            <div className="input-box">
              <label for="DateInput" class="visuallyhidden">Date</label>
              <span className="details">Date</span>
              <input type="date" id="DateInput" className="dateInput" placeholder="11/14/2022" name="Date" max="9999-12-31" required />
            </div>
    
            <div className="input-box">
              <label for="AmountInput" class="visuallyhidden">Amount</label>
              <span className="details">Amount</span>
              <input 
              type="text" 
              id="AmountInput" 
              className="amountInput" 
              data-type="currency"
              onKeyPress={handleCurrencyKeyPress}
              placeholder="Enter the amount" 
              autoComplete="false"
              ref={amntRef}
              name="Amount" 
              required />
            </div>
          </div>
          <div className="button">
            <label for="button" class="visuallyhidden">Submit</label>
            <input type="submit" value="Submit" id="button" />
        </div>
        </form>
    </div>
    </section>

    <section>
        <p id="responseMessage"></p>
        <table id="tbl" className="table_sortable">
        <thead>
        <tr>
            <th id="typeHeader">
            <button id="typeButton">Type <span aria-hidden="true" id="typeTriangle"></span></button>
            </th>
            <th id="categoryHeader">
            <button id="categoryButton">Category <span aria-hidden="true" id="categoryTriangle"></span></button>
            </th>
            <th id="descHeader">
            <button id="descButton">{descriptionHeader} <span aria-hidden="true" id="descTriangle"></span></button>
            </th>
            <th id="dateHeader">
            <button id="dateButton">Date Entered <span aria-hidden="true" id="dateTriangle"></span></button>
            </th>
            <th id="amntHeader">
            <button id="amntButton">{amntHeader} <span aria-hidden="true" id="amntTriangle"></span></button>
            </th>
            <th>Action</th>
        </tr>
        </thead>
        <tbody>
            {rows.map((row, index) => (
                <tr key={index}>
                <td id="type">{row.type}</td>
                <td>{row.category}</td>
                <td id="desp">{row.description}</td>
                <td>{formatDate(row.date)}</td>
                <td>{'$' + row.amount.toLocaleString('en-US', {'minimumFractionDigits':2,'maximumFractionDigits':2})}</td>
                <td><button id="deleteBtn" onClick={() => onDeleteRow(index)}>Delete</button></td>
                </tr>
            ))}
        </tbody>
        </table>
    </section>

    <section className="summary-link">
        <a href="/summary" className="hero-btn gold-btn" id="LibertyBtn">
        Back to Summary
        </a>
    </section>


    <Footer></Footer>
    </>
);
}

export default Expenses;